"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.E_TIME_OUT = exports.exceptionRegistry = void 0;
const $Exceptions = require("@reolink/web.exception-js");
exports.exceptionRegistry = $Exceptions.createExceptionRegistry({
    'module': 'fe.client',
    'types': {
        'client': {
            index: $Exceptions.createIncreaseCodeIndex(0x100000000)
        }
    }
});
exports.E_TIME_OUT = exports.exceptionRegistry.register({
    name: 'time_out',
    message: 'Request timeout',
    metadata: {},
    type: 'client'
});
//# sourceMappingURL=Errors.js.map